import { useQuery } from '@tanstack/react-query';
import { fetchStations } from '../api/coops';

/** The full CO-OPS station list, loaded once per session (StationManager). */
export function useStationsQuery(enabled = true) {
  return useQuery({
    queryKey: ['coops-stations'],
    queryFn: ({ signal }) => fetchStations(signal),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
    enabled,
  });
}
